import { get, post } from './http-calls';
import { memoize } from 'lodash';
export const getSavePaperData = async () => {
    let res = await get('Jobdocuments/DocumentsProcessed', { useAuthToken: true });
    return res;
};
